module.exports = __webpack_public_path__ + "static/media/cedula3.d771c3f0.png";